import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable()
export class SettingsService {
  private user: any;
  private app: any;
  private layout: any = {
    isFixed: true,
    isCollapsed: false,
    isBoxed: false,
    offsidebarOpen: false,
    isCollapsedText: false,
    // Menu lateral abierto en telefonos/tablets (no se persiste en preferencias)
    asideMobileOpen: false,
    asideHover: false,
    theme: null,
    viewAnimation: "ng-fadeInUp"
  };
  public settingsPonds = {
    status: false,
    listSelected: []
  };

  private gatewayFormState = {
    name: null,
    status: false,
    gateway: null,
    farm: null,
    coordinates: {
      id: "",
      lat: "",
      lng: ""
    }
  };
  private gatewayFormStatus = new BehaviorSubject<boolean>(false);

  /** Emite cuando se abre (true) o se cierra (false) el formulario de gateway. */
  readonly gatewayFormStatus$: Observable<boolean> = this.gatewayFormStatus.asObservable();

  /**
   * Estado del formulario de gateway (se abre en un modal desde ModalsComponent).
   * @returns estado actual del formulario.
   */
  get GatewayForm() {
    return this.gatewayFormState;
  }

  /**
   * Reemplaza el estado del formulario de gateway y avisa si cambio "status".
   * @param value nuevo estado del formulario.
   */
  set GatewayForm(value) {
    this.gatewayFormState = value;
    if (value.status !== this.gatewayFormStatus.value) {
      this.gatewayFormStatus.next(value.status);
    }
  }
  public TesteoGateway = {
    status: false,
    farm: null
  };

  constructor() {
    // App Settings
    // -----------------------------------
    this.app = {
      name: "NAS",
      year: new Date().getFullYear()
    };
  }

  getAppSetting(name) {
    return name ? this.app[name] : this.app;
  }
  getUserSetting(name) {
    return name ? this.user[name] : this.user;
  }
  getLayoutSetting(name) {
    return name ? this.layout[name] : this.layout;
  }

  setAppSetting(name, value) {
    if (typeof this.app[name] !== "undefined") {
      this.app[name] = value;
    }
  }
  setUserSetting(name, value) {
    if (typeof this.user[name] !== "undefined") {
      this.user[name] = value;
    }
  }
  setLayoutSetting(name, value) {
    if (typeof this.layout[name] !== "undefined") {
      return (this.layout[name] = value);
    }
  }

  toggleLayoutSetting(name) {
    return this.setLayoutSetting(name, !this.getLayoutSetting(name));
  }
  closeAll() {
    this.settingsPonds = {
      status: false,
      listSelected: []
    };
    this.GatewayForm = {
      name: null,
      status: false,
      gateway: null,
      farm: null,
      coordinates: {
        id: "",
        lat: "",
        lng: ""
      }
    };
    this.TesteoGateway = {
      status: false,
      farm: null
    };
  }
}
